import React from "react";
import RadioChecked from "./RadioButtonCheckedFilled.svg";
import RadioUnchecked from "./RadioButtonUncheckedFilled.svg";

export default function GridRadio({ choices, name, form, setForm, isTabletOrMobile = false }) {
  function handleClick(id) {
    setForm({ ...form, [name]: id });
  }
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  return (
    <>
      {error && <div style={{ color: "red", margin: "1rem 0" }}>{error}</div>}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "1rem"
        }}
      >
        {choices.map((n, idx) => (
          <div
            key={idx}
            style={{
              background: form[name] === n.id ? "#F4F2E6" : "",
              border:
                idx === 0 ? "1px solid #B3956E" : form[name] !== n.id ? "1px solid #F4F2E6" : "",
              borderRadius: "21px",
              cursor: "pointer",
              marginBottom: "1rem",
              gridColumn: isTabletOrMobile ? "span 6" : "span 3"
            }}
            tabIndex="0"
            onClick={() => handleClick(n.id)}
            onKeyPress={(e) => (e.key === "Enter" ? handleClick(n.id) : null)}
          >
            <div
              style={{
                color: "#011F31",
                letterSpacing: "0.25px",
                lineHeight: "20px",
                padding: "1.25rem"
              }}
            >
              <div style={{ marginRight: ".5rem" }}>
                <div
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "left",
                    marginBottom: "1rem"
                  }}
                >
                  <div style={{ fontSize: 24, marginRight: "1rem" }}>
                    {form[name] === n.id ? <RadioChecked /> : <RadioUnchecked />}
                  </div>
                  <div style={{ textAlign: "left", fontFamily: "BentonSans", fontWeight: "700" }}>
                    {n.name}
                  </div>
                </div>
                <div style={{ textAlign: "left", marginBottom: "1rem" }}>{n.intro}</div>
                <div>{n.description}</div>
              </div>
              <div style={{}}>{n.detail}</div>
            </div>
            <div style={{}}>
              <div></div>
              <div style={{}}>{n.extra}</div>
              <div></div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
